import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { APP_ROUTE } from 'app/app-routing.constant';

@Component({
  selector: 'kh-demo-message-modal',
  templateUrl: './demo-message-modal.component.html',
  styleUrls: ['./demo-message-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DemoMessageModalComponent {
  private readonly router = inject(Router);
  private readonly bsModalRef = inject(BsModalRef);

  public async addClass(): Promise<void> {
    const route = APP_ROUTE.TEACHERS.CLASS_MANAGEMENT.route();
    await this.router.navigate(route, { queryParams: { addClass: true } });
    this.bsModalRef.hide();
  }

  public close(): void {
    this.bsModalRef.hide();
  };
}
